<template>
	<div v-show="isActive" style="height:inherit">
		<slot></slot>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				isActive: false
			}
		},
		props: {
			name: { required: true },
			selected: { default: false },
			iconSrc: { default: null },
			tabClass: {default:''}
			
		},		
		mounted() {
			this.isActive = this.selected;
		}
	}
</script>
